import { Stack } from "@mui/material";
import React from "react";
import { FaInfinity } from "react-icons/fa6";

const IntroductionSection = () => {
  return (
    <Stack>
      <Stack
        sx={{
          width: "100%",
          fontSize: {
            xs: "22px",
            sm: "26px",
            md: "30px",
            lg: "34px",
          },
          color: "#054E91",
          fontFamily: "'Roboto', sans-serif",
          fontWeight: 600,
          letterSpacing: "0.5px",
          textAlign: "left",
          fontWeight: { xs: 600, sm: 600, md: 600, lg: 600, xl: 600 },
          marginBottom: {
            xs: "20px",
            sm: "20px",
            md: "20px",
            lg: "28px",
            xl: "20px",
          },
          marginTop: {
            xs: "20px",
            sm: "20px",
            md: "20px",
            lg: "64px",
            xl: "64px",
          },

          display: "flex",
          flexDirection: "row",
          // padding: "20px",
          // border: "1px solid blue",
        }}
      >
        <Stack
          sx={{
            //  border: "1px solid red",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack
            sx={{
              width: { xl: "6px", lg: "6px", xs: "4px" },
              height: { xs: "22px", sm: "36px", md: "30px" },
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              border: "1px solid rgb(5 78 146)",
              // backgroundColor: "rgb(5 78 146)",
              backgroundColor: "rgb(5 78 146)",
              marginRight: {
                xs: "8px",
                sm: "8px",
                md: "12px",
                lg: "12px",
                xl: "12px",
              },

              marginLeft: {
                xs: "12px",
                sm: "0px",
                md: "0px",
                lg: "0px",
                xl: "0px",
              },
              borderTopRightRadius: "8px", // Adjust the value as needed
              borderBottomRightRadius: "8px", // Adjust the value as needed
            }}
          >
            <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
          </Stack>
        </Stack>
        <Stack
          sx={{
            display: {
              xl: "flex",
              lg: "flex",
              md: "flex",
              sm: "flex",
              xs: "none",
            },
          }}
        >
          Single platform, infinite ways to grow your business
        </Stack>

        <Stack
          sx={{
            display: {
              xl: "none",
              lg: "none",
              md: "none",
              sm: "none",
              xs: "flex",
            },
          }}
        >
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              flexWrap: "nowrap",
              fontFamily: "'Roboto', sans-serif",
              fontWeight: "bold",
              color: "rgb(5 78 146)",
              fontSize: {
                xs: "19px",
                sm: "16px",
                md: "18px",
              },
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              // paddingBottom: "10px"
              // marginBottom: "6px"
            }}
          >
            <span style={{ whiteSpace: "nowrap" }}>One platform,&nbsp;</span>
            {/* <FaInfinity style={{ margin: "0 4px" }} /> */}
            <span style={{ whiteSpace: "nowrap" }}>endless business growth</span>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        sx={{
          width: "100%",
          fontSize: {
            xs: "15px",
            sm: "17px",
            md: "20px",
          },
          lineHeight: { xs: 1.5, sm: 1.80, md: 1.2 },
          fontFamily: "'Roboto', sans-serif",
          color: "text.secondary",
          textAlign: "left",
          border: "1px solid white",
          backgroundColor: "#dae9f8;",
          // padding: "20px",
          padding: 1,
          borderRadius: "8px",
          display: {
            xl: "flex",
            lg: "flex",
            md: "flex",
            sm: "flex",
            xs: "none",
          },
        }}
      >
        {/* #1976d2 */}
        <span sx={{ display: "inline-flex", flexDirection: "row" }}>
          Take the leap with{" "}
          <span style={{ color: "#054E91", fontSize: "21px", fontWeight: 600 }}>
            Vertex
          </span>{" "}
          <span style={{ color: "#1F85C0", fontSize: "21px", fontWeight: 600 }}>
            Suite’s
          </span>{" "}
           smart business solutions- streamline operations, engage customers and fuel growth with innovative tools and data-driven insights that transform processes and secure sustainable success.
        </span>

      </Stack>
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack
          sx={{
            width: "95%",
            fontFamily: "'Roboto', sans-serif",
            fontSize: {
              xs: "16px",
              sm: "20px",
              md: "16px",
              lg: "24px",
              xl: "24px",
            },
            lineHeight: {
              xs: "24px",
              sm: "28px",
              md: "32px",
              lg: "32px",
              xl: "32px",
            },
            fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
            color: "#333",
            // color: "white",
            // textAlign: "justify",
            textAlign: "left",
            border: "1px solid white",
            backgroundColor: "#dae9f8;",
            // padding: "20px",
            padding: 1,
            borderRadius: "8px",
            display: {
              xl: "none",
              lg: "none",
              md: "none",
              sm: "none",
              xs: "flex",
            },
            marginBottom: "20px",
          }}
        >
          {/* #1976d2 */}
          <span sx={{ display: "inline-flex", flexDirection: "row" }}>
            <span style={{ color: "#054E91", fontSize: "16px", fontWeight: 700 }}>
              Vertex
            </span>{" "}
            <span style={{ color: "#1F85C0", fontSize: "16px", fontWeight: 700 }}>
              Suite
            </span>{" "}
            helps businesses grow by improving operations, customer interaction and decision - making with the help of smart tools and insights.
          </span>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default IntroductionSection;
